import React, { useEffect, useState } from "react";
import styles from '../styles/main.module.scss'
// import '../screens/styles/NewHome.css';
import google from '../assets/image/google.png'
import apple from '../assets/image/apple.png'
import banner from '../assets/image/banner.png'
import breakfast from '../assets/image/breakfast.png'
import soup from '../assets/image/soup.png'
import main_course from '../assets/image/main_course.png'
import rice_pasta from '../assets/image/rice_pasta.png'
import meat_chicken_fish from '../assets/image/meat_chicken_fish.png'
import snack from '../assets/image/snack.png'
import dessert from '../assets/image/dessert.png'
import pastry from '../assets/image/pastry.png'

import rollerSkate from '../assets/image/roller_skate.png'
import running from '../assets/image/running.png'
import skateBoard from '../assets/image/skateboard.png'
import pingPong from '../assets/image/ping_pong.png'
import tennis from '../assets/image/tennis.png'
import volleyball from '../assets/image/volleyball.png'
import yoga from '../assets/image/yoga.png'
import { Link } from "react-router-dom";

const activities = [
    {id: 0, name: 'Breakfast'}, 
    {id: 1, name: 'Soup'},
    {id: 2, name: 'Main Course'}, 
    {id: 3, name: 'Rice-Pasta'}, 
    {id: 4, name: 'Meat-Chicken-Fish'},
    {id: 5, name: 'Snack'},
    {id: 6, name: 'Dessert'},
    {id: 7, name: 'Pastry'},
    {id: 8, name: 'Roller Skate'},
    {id: 9, name: 'Running'},
    {id: 10, name: 'SkateBoard'},
    {id: 11, name: 'Ping Pong'},
    {id: 12, name: 'Tennis'},
    {id: 13, name: 'Volleyball'},
    {id: 14, name: 'Yoga'},
   ];

function selectActivity (item) {
    switch (item) {
        case 'Breakfast':
            return breakfast
        case 'Soup':
            return soup
        case 'Main Course':
            return main_course
        case 'Rice-Pasta':
            return rice_pasta
        case 'Meat-Chicken-Fish':
            return meat_chicken_fish
        case 'Snack':
            return snack
        case 'Dessert':
            return dessert
        case 'Pastry':
            return pastry

        case 'Roller Skate':
            return rollerSkate
        case 'Running':
            return running
        case 'SkateBoard':
            return skateBoard
        case 'Ping Pong':
            return pingPong
        case 'Tennis':
            return tennis
        case 'Volleyball':
            return volleyball
        case 'Yoga':
            return yoga
    }
}

function frameActivity (item) {
    return (
        <div className={styles.frameMain}>
            <img className={styles.picMain} src={selectActivity(item.name)} alt="test" />
            <h4 className={styles.picMain__title}>{item.name}</h4>
        </div>
    )
}

function Main () {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth)
    useEffect(() => {
        window.addEventListener('resize', detectSize)

        return () => {
            window.removeEventListener('resize', detectSize)
        }
    }, [screenWidth])

    const detectSize = () => {
        setScreenWidth(window.innerWidth)
    }

    return (
        <div className={styles.main}>
            <div className={styles.container1}>
                <div className={styles.container1__frame1}>
                    <img className={styles.container1__frame1__img} src={banner} alt="test" />
                </div>
                <div className={styles.container1__frame2}>
                    <p className={styles.info1}>
                        Ham Yap is an online mobile app that offers alternative recipes for mothers, 
                        children and babies with food allergies. Although the number of babies born 
                        with allergies is quite high today, there are very few sources to solve this 
                        problem. However, if food allergies are taken under control at a young age, 
                        they can be eliminated later in life. Our aim here is to provide healthy 
                        recipes for parents who have babies or children with food allergy. 
                        In addition, since allergenic foods can be passed to babies through 
                        breast milk, we aim to help mothers find suitable recipes not only for 
                        their babies but also for themselves. Finally, we also offer healthy 
                        nutrition and alternative recipes. 
                    </p>
                </div>
            
                {/* <div className={styles.frame4}>TEST 4</div> */}

            </div>
            <div className={styles.container2}>
                <div className={styles.frame1}>
                    <p className={styles.info2}>
                        Food allergy is a problem that seriously affects health and reduces the standard of 
                        living. Research shows that the number of children taken to the doctor for food 
                        allergies has tripled in the last two decades 
                        (https://www.acibadem.com.tr/hayat/besin-alerjisi-cocuklarin-gelisimini-etkiliyor/). 
                        In addition to the immediate health threats caused by allergic reactions, 
                        food allergies also lead to inadequate and unbalanced nutrition in children. 
                        For all these reasons, parents find it difficult to prepare a variety of meals for 
                        their children with food allergies or intolerances. To solve this problem, parents 
                        seek help from infant-child allergy books, but this method does not appeal to many 
                        parents because it is difficult to search for recipes in books. In addition, there 
                        is no access to up-to-date recipes in books.
                    </p>
                    <p className={styles.info2}>
                        Another method is to seek help from online resources, but while there are many recipes 
                        for adults, there are no apps that offer recipes for infant and child allergies.The project 
                        aims to provide parents with quick access to up-to-date recipes via their smartphones. 
                        As a result, we aim to provide parents with different recipes with alternative products for
                        their babies or children and to facilitate access to them online.
                    </p>
                </div>
            </div>

            <div className={styles.container3}>
                {frameActivity(activities[0])}
                {frameActivity(activities[1])}
                {frameActivity(activities[2])}
                {frameActivity(activities[3])}
            </div>
            <br/>
            <div className={styles.container3}>
                {frameActivity(activities[4])}
                {frameActivity(activities[5])}
                {frameActivity(activities[6])}
                {frameActivity(activities[7])}
            </div>
            <br/>

            <div className={styles.container4}>
                <div className={styles.linkCol1}>
                    <img class={styles.pic1} src={google} alt="Snow"  />
                    <button class={styles.pic1__btn} onClick={() => window.open("https://play.google.com/store/apps/details?id=com.letsup.hamyap&hl=tr&gl=US") }></button>
                </div>
                <div className={styles.linkCol2}>
                    <img class={styles.pic2} src={apple} alt="Snow"  />
                    <button class={styles.pic2__btn} onClick={() => window.open("https://apps.apple.com/us/app/ham-yap/id6447787659") }></button>
                </div>    
                {/* <div class={styles.pic}>
                    <img class={styles.pic__main__google} src={google} alt="Snow"  />
                    <button class={styles.pic__btn} onClick={() => window.open("https://play.google.com/store/apps/details?id=com.letsup.letsgetup&hl=tr&gl=US") }></button>
                </div>
              
                <div class={styles.pic}>
                    <img class={styles.pic__main} src={apple} alt="Snow"  />
                    <button class={styles.pic__btn} onClick={() => window.open("https://apps.apple.com/us/app/lets-get-up/id1583985435")} ></button>
                </div> */}
            </div>
        </div>

    )
}

export default Main;